import { Dialog, DialogProps } from '@mui/material';
import { MouseEventHandler, PropsWithChildren, ReactElement, createContext, useContext } from 'react';
import { noop } from '@synergy/utils';

export type PoolModalContextValue = Pick<DialogProps, 'maxWidth'> & {
    onClose: MouseEventHandler<HTMLButtonElement>;
};

export const usePoolModalContext = (): PoolModalContextValue => useContext(PoolModalContext);

const PoolModalContext = createContext<PoolModalContextValue>({
    onClose: noop,
});

export type PoolModalProps = PropsWithChildren<DialogProps>;

export const PoolModal = (props: PoolModalProps): ReactElement => {
    const { children, ...dialogProps } = props;

    return (
        <Dialog {...dialogProps}>
            <PoolModalContext.Provider
                value={{
                    maxWidth: dialogProps.maxWidth,
                    onClose: dialogProps.onClose as MouseEventHandler<HTMLButtonElement>,
                }}
            >
                {children}
            </PoolModalContext.Provider>
        </Dialog>
    );
};
